import { useEffect, useRef, useState } from "react";
import { countdownParts } from "../lib/format";

export function Countdown({
  target,
  onDone,
  compact = false,
  neon = false,
}: {
  target: string | Date;
  onDone?: () => void;
  compact?: boolean;
  neon?: boolean;
}) {
  const [parts, setParts] = useState(() => countdownParts(target));
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useEffect(() => {
    const interval = setInterval(() => {
      const next = countdownParts(target);
      setParts(next);
      if (next.done) {
        clearInterval(interval);
        onDoneRef.current?.();
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [target]);

  if (parts.done) {
    return <span className="text-xs font-semibold text-white/50">Ended</span>;
  }

  if (compact) {
    const urgent = parts.d === 0 && parts.h === 0 && parts.m < 5;
    return (
      <span
        className={`font-display text-xs tabular-nums ${neon ? (urgent ? "text-red-400 animate-pulse" : "text-brand-pink") : "text-brand-pink"}`}
      >
        {parts.d > 0 && `${parts.d}d `}
        {String(parts.h).padStart(2, "0")}:{String(parts.m).padStart(2, "0")}:{String(parts.s).padStart(2, "0")}
      </span>
    );
  }

  const cells = [
    ...(parts.d > 0 ? [{ v: parts.d, l: "days" }] : []),
    { v: parts.h, l: "hrs" },
    { v: parts.m, l: "min" },
    { v: parts.s, l: "sec" },
  ];
  return (
    <div className="flex items-center gap-2">
      {cells.map((cell) => (
        <div key={cell.l} className="flex min-w-12 flex-col items-center rounded-lg bg-white/5 px-2 py-1.5">
          <span className="font-display text-lg font-semibold tabular-nums text-white">
            {String(cell.v).padStart(2, "0")}
          </span>
          <span className="text-[9px] uppercase tracking-widest text-white/40">{cell.l}</span>
        </div>
      ))}
    </div>
  );
}
